import { HeaderMode } from '../../table-header/enums/HeaderMode';
import { GridState, GridStateActions, GridEvent, GridNotification, NotificationData } from './grid-state.interface';

/**
 * Duplication State - When duplicated rows are being created
 */
export class DuplicationState implements GridState {
  getMode(): HeaderMode {
    return HeaderMode.Duplication;
  }

  onEnter(actions: GridStateActions): void {
    actions.disableCheckboxColumn();
    actions.applyBoldToDuplicatedRows();
  }

  onExit(actions: GridStateActions, event: GridEvent): void {
    if (event === 'SAVE') {
      actions.cleanDuplicatedRows();
    } else if (event === 'CANCEL') {
      actions.cleanAllState();
    }
  }

  canTransitionTo(event: GridEvent): HeaderMode | null {
    switch (event) {
      case 'SAVE':
        return HeaderMode.Idle;
      case 'CANCEL':
        return HeaderMode.Idle;
      default:
        return null;
    }
  }

  handleNotification(notification: GridNotification, data: NotificationData, actions: GridStateActions): GridEvent | null {
    switch (notification) {
      case 'CELL_EDIT_ATTEMPT':
        // Block editing of original rows (id > 0) in duplication mode
        if (data.itemId && data.itemId > 0) {
          actions.blockCellEdit();
        }
        return null;

      case 'EDIT_MODE_REQUESTED':
        actions.disableEditColumn();
        actions.enableSingleClickEdit();
        actions.refreshGrid();
        actions.applyBoldToDuplicatedRows();
        return null;

      case 'DUPLICATES_CHANGED':
        if (data.hasDuplicates === false) {
          return 'SAVE';
        }
        return null;

      default:
        return null;
    }
  }

  getDataToSave(context: { duplicatedRows: any[]; editedRows: Map<number, any> }): any[] {
    return context.duplicatedRows;
  }
}
